<template>
  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width" v-show="!cadastro"> 
          <div slot="header">
            <h4 class="card-title">Lista de Categorias</h4>
            <button class="btn btn-info" @click="exibirCadastro" v-if="cadastroWeb">Nova Categoria</button>
          </div>
          
          <div class="px-3">
            <div class="mb-3">
              <div v-for="categoria of categorias" class="row py-2 px-2 bordered-block-table only-mobile">
                <div class="col-6">
                  <strong>{{ categoria.descricao}}</strong>
                </div>
                <div class="col-2">
                  <button class="btn btn-sm btn-edit px-2 py-1" @click="editarCategoria(categoria)" style="font-size: 10px"><i class="fa fa-pencil"></i></button>
                </div>
              </div>
            </div>

            <table class="table table-striped hidden-mobile">
              <thead>
                <tr>
                  <th style="width: 300px" class="text-right">Categoria</th>
                  <th class="text-center" v-if="cadastroWeb"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="categoria of categorias">
                  <td class="text-right">{{ categoria.descricao }}</td>
                  <td class="text-right">
                    <template v-if="cadastroWeb">
                      <button class="btn btn-sm btn-edit mr-1 px-2 py-1" @click="editarCategoria(categoria)" style="font-size: 10px"><i class="fa fa-pencil"></i></button>
                      <button class="btn btn-sm btn-danger px-2 py-1" @click="excluirCategoria(categoria)" style="font-size: 10px" ><i class="fa fa-close"></i></button>
                    </template>
                  </td>
                </tr>
                <tr v-if="!categorias || !categorias.length">
                  <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
                </tr>
              </tbody>
            </table>

            <div class="row">
              <div class="col-12 col-md-6 text-center-mobile">
                Mostrando de {{ from }} até {{ to }} de {{ total}} registros
              </div>
              <div class="col-12 col-md-6 text-right text-center-mobile mt-2-mobile">
                  <paginate
                  :pageCount="pageCount"
                  :clickHandler="changePage"
                  :prevText="'Ante.'"
                  :nextText="'Próx.'"
                  :containerClass="'pagination'">
                </paginate>
              </div>
            </div>
          </div>
        </card>

        <card card-body-classes="table-full-width" v-show="cadastro"> 
          <div class="card-body" >
            <h4 class="card-title">Cadastro de Categoria</h4>
            <button class="btn btn-info" @click="exibirLista">Exibir categoria</button>
            <form class="m-t-40" v-on:submit.prevent="update(categoria)">
              <div class="row col-md-8 col-12 pt-10">
                <div class="form-group col-md-9">
                  <label>Nome da Categoria</label>
                  <input type="text" class="form-control" placeholder="Obrigatório" required v-model="categoria.descricao">
                </div>      
                <div class="col-md-12">
                  <button class="btn btn-info mr-10" :class="{ disabled: percentCompleted != 0 && percentCompleted != 100 }">{{ categoria.codigo ? 'Salvar': 'Cadastrar'}}</button>
                  <!-- <button class="btn btn-secondary ml-3 mr-10">Limpar</button> -->
                </div>
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
  } from 'src/components'
  import moment from 'moment'
  import CategoriaFiscalService from '@/services/CategoriaFiscalService.js'
  import { http } from '@/services/HttpService.js'

  export default {
    components: {
      Card,
      moment
    },
    data() {
      return {
        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_fim_cabecalho:moment().format("DD/MM/YYYY"),
        data_inicio_cabecalho:moment().format("DD/MM/YYYY"),
        categorias: [],
        ean:"",
        current_page: 1,
        pageCount: 0,
        cadastro: false,
        categoria: {descricao:""},
        from: 0,
        last_page:0,
        to: 0,
        total: 0,
        hasImage: false,
        image: null,
        loadingUpload: false,
        percentCompleted: 0,
        cadastroWeb: localStorage.getItem('config_modulo_cadastro_web') == "true" && !window.accessLevel ? true : false,

      }
    },
    methods:{
      loadCategorias() {
        CategoriaFiscalService.load(`?page=${this.current_page}`).then(res => {
          console.log(res.data);
          this.pageCount = res.data.last_page
          this.categorias = res.data.data;
          console.log();
          this.from = res.data.from
          this.to = res.data.to
          this.last_page = res.data.last_page
          this.total = res.data.total
          console.log(this.categorias);

        })
      
      },
      editarCategoria(categoria){
        this.categoria = categoria
        this.cadastro = true;
      },
      update(Categoria){
        if(Categoria.codigo){
          CategoriaFiscalService.update(Categoria).then(res => {
            this.loadCategorias()
            this.cadastro = false;
            this.$swal('Produto atualizado com sucesso!','', 'success')
          }).catch(error =>{
            this.$swal({
                text: error.response,
                type: "error",
            });
          });
        }else{
          CategoriaFiscalService.create(Categoria).then(res => {
            this.loadCategorias();
            this.cadastro = false;
            this.$swal('Produto cadastrado com sucesso!','', 'success')
          }).catch(error =>{
            console.log(error);
                this.$swal({
                    text: error.resonse,
                    type: "warning",
                });
              });
        }
      },
      exibirLista(){
        this.loadCategorias()
        this.cadastro = false;
      },
      exibirCadastro(){
        this.Categoria = ({});
        this.cadastro = true;
      },
      excluirCategoria(Categoria){
        this.$swal({
          title: "Desativar esse categoria ?",
          text: "Atenção essa operacao não pode ser revertida !",
          type: "warning",
          showCancelButton: true,
          cancelButtonAriaLabel: 'Cancelar',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#ef5350',
          confirmButtonText:'Desativar',
        }).then(result => {
          if(result.value){
            CategoriaFiscalService.destroy(Categoria.codigo).then(res => {
              this.loadCategorias()
              this.cadastro = false;
              this.$swal('Categoria desativado com sucesso!','', 'success')
            }).catch(e => {
              this.$swal('Erro ao excluir', e,'error')
            })
          }
        });
      },
      changePage(page) {
        this.current_page = page
        this.loadCategorias()
      },
    },
    mounted() {
      this.loadCategorias()
    }
  }
</script>
